import differenceWith from 'lodash/differenceWith'
import isEqual from 'lodash/isEqual'
import toPairs from 'lodash/toPairs'
import fromPairs from 'lodash/fromPairs'

export const checkEmpty = (obj, constraint: string[] = []) => {
  return constraint.every(key => !!obj[key])
}

export const differenceTwoObject = (base, comparison) => {
  const changes = differenceWith(toPairs(base), toPairs(comparison), isEqual)
  return fromPairs(changes)
}
